import React, { useState } from "react";
import DataTable from "react-data-table-component";

// Sample data
const sampleData = [
  { id: 1, name: "Alice", email: "alice@example.com", phone: "123-456-7890" },
  { id: 2, name: "Bob", email: "bob@example.com", phone: "987-654-3210" },
  {
    id: 3,
    name: "Charlie",
    email: "charlie@example.com",
    phone: "555-555-5555",
  },
];

// All columns
const allColumns = [
  {
    name: "Name",
    selector: (row) => row.name,
    sortable: true,
    id: "name",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    id: "email",
  },
  {
    name: "Phone",
    selector: (row) => row.phone,
    sortable: true,
    id: "phone",
  },
];

const ColumnFilterTable = () => {
  const [visibleColumnIds, setVisibleColumnIds] = useState(
    allColumns.map((col) => col.id)
  );
  const [tempSelection, setTempSelection] = useState(visibleColumnIds);
  const [showModal, setShowModal] = useState(false);

  const handleToggleTemp = (id) => {
    setTempSelection((prev) =>
      prev.includes(id) ? prev.filter((colId) => colId !== id) : [...prev, id]
    );
  };

  const applyFilter = () => {
    setVisibleColumnIds(tempSelection);
    setShowModal(false);
  };

  const visibleColumns = allColumns.filter((col) =>
    visibleColumnIds.includes(col.id)
  );

  return (
    <div style={{ padding: "20px" }}>
      <h3>Column Filter Table</h3>

      <button onClick={() => setShowModal(true)}>Filter Columns</button>

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              minWidth: "300px",
            }}
          >
            <h4>Select Columns to Display</h4>
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {allColumns.map((col) => (
                <label
                  key={col.id}
                  style={{ display: "block", marginBottom: "8px" }}
                >
                  <input
                    type="checkbox"
                    checked={tempSelection.includes(col.id)}
                    onChange={() => handleToggleTemp(col.id)}
                  />{" "}
                  {col.name}
                </label>
              ))}
            </div>
            <div
              style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <button onClick={applyFilter}>Apply Filter</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <DataTable
        columns={visibleColumns}
        data={sampleData}
        pagination
        highlightOnHover
        responsive
      />
    </div>
  );
};

export default ColumnFilterTable;
